import {useCallback, useState} from 'react'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import useCancelToken from '../../../../_gori/hooks/UseCancelToken'
import A1BatchService from '../core/_requests'

type DownloadBatchOptions = {
  batchIds: string[]
  batchName?: string
  onError?: (error: any) => void
}

export const useA1BatchHelper = () => {
  const intl = useIntl()
  const {newCancelToken, isCancel} = useCancelToken()
  const [loading, setLoading] = useState({
    downloadBatch: false,
  })

  const downloadA1Batch = useCallback(
    async ({batchIds, batchName, onError}: DownloadBatchOptions) => {
      const config = {cancelToken: newCancelToken(), responseType: 'blob' as const}
      try {
        setLoading((prev) => ({...prev, downloadBatch: true}))
        const res = await A1BatchService.downloadA1Batch(
          {
            batch_ids: batchIds,
          },
          config
        )

        let filename: string
        let mimeType: string

        if (batchIds.length === 1) {
          filename = `${batchName || 'SmartA1-Batch'}.csv`
          mimeType = 'text/csv;charset=utf-8;'
        } else {
          filename = `SmartA1-Batches-${Date.now()}.zip`
          mimeType = 'application/zip'
        }

        const blob = new Blob([res], {type: mimeType})
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error: any) {
        if (isCancel(error)) return
        if (onError) {
          onError(error)
        } else {
          toast.error(intl.formatMessage({id: 'ERROR'}))
        }
      } finally {
        setLoading((prev) => ({...prev, downloadBatch: false}))
      }
    },
    [intl, newCancelToken, isCancel]
  )

  return {
    downloadA1Batch,
    loading,
  }
}
